import React, { useState } from "react";
import { Modal, Input, message, Spin, Image, Select } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../context/api";
import BigProjectImageUploader from "../imageUploader/BigProjectImageUploader";
import "./bigprojectcard.scss";

const { TextArea } = Input;

const BigProjectCard = ({ project, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title_uz: project.title_uz || '',
    title_ru: project.title_ru || '',
    title_en: project.title_en || '',
    text_uz: project.text_uz || '',
    text_ru: project.text_ru || '',
    text_en: project.text_en || '',
    imageFile: project.image
  });

  const deleteProject = async () => {
    setLoading(true);
    try {
      await api.delete(`/bigproject/${project.id}`);
      message.success("Loyiha muvaffaqiyatli o'chirildi");
      onUpdate();
    } catch (error) {
      console.error("Delete error:", error);
      message.error(error.response?.data?.message || "Loyihani o'chirishda xatolik yuz berdi");
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const updateProject = async () => {
    setLoading(true);
    const formDataToSend = new FormData();
    
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formDataToSend.append(key, value);
      }
    });
    
    if (formData.imageFile && typeof formData.imageFile !== 'string') {
      formDataToSend.append("image", formData.imageFile);
    }

    try {
      await api.patch(`/bigproject/${project.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      message.success("Loyiha muvaffaqiyatli yangilandi");
      onUpdate();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Update error:", error);
      message.error(error.response?.data?.message || "Loyihani yangilashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <div className="bigproject-card">
        <div className="card-media">
          <Image
            src={project.image}
            alt={project.title_uz}
            preview={false}
            style={{
              width: '100%',
              height: '180px',
              objectFit: 'cover'
            }}
          />
          <div className="card-actions">
            <button 
              onClick={() => {
                setEditMode(true);
                setIsModalOpen(true);
              }}
            >
              <EditOutlined /> Tahrirlash
            </button>
            <button style={{ color: 'white' , backgroundColor: 'red' }}
              onClick={() => {
                setEditMode(false);
                setIsModalOpen(true);
              }}
            >
              <DeleteOutlined  /> O'chirish
            </button>
          </div>
        </div>
        
        <div className="card-content">
          <h3>{project.title_uz}</h3>
          <p>{project.title_ru}</p>
          <div className="text-preview">
            {project.text_uz && <p>{project.text_uz.substring(0, 100)}...</p>}
          </div>
        </div>
      </div>

      <Modal
        title={editMode ? "Loyihani tahrirlash" : "O'chirishni tasdiqlang"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={editMode ? 800 : 520}
      >
        <Spin spinning={loading}>
          {editMode ? (
            <div className="edit-form">
              <div className="current-image">
                <Image
                  src={typeof formData.imageFile === 'string' ? 
                    formData.imageFile : 
                    URL.createObjectURL(formData.imageFile)}
                  alt="Current"
                  style={{ maxWidth: '100%', maxHeight: '200px' , objectFit: 'cover' }}
                />
              </div>
              
              <BigProjectImageUploader
                imageFile={formData.imageFile}
                setImageFile={(file) => handleFormChange('imageFile', file)}
              />
              
              <div className="form-group">
                <label>Sarlavha (O'zbekcha)</label>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange('title_uz', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Sarlavha (Ruscha)</label>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange('title_ru', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Sarlavha (Inglizcha)</label>
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange('title_en', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Matn (O'zbekcha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange('text_uz', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Matn (Ruscha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange('text_ru', e.target.value)}
                />
              </div>
              
              <div className="form-group">
                <label>Matn (Inglizcha)</label>
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange('text_en', e.target.value)}
                />
              </div>
              
              <div className="form-actions">
                <button 
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button 
                  className="save-btn"
                  onClick={updateProject}
                >
                  Saqlash
                </button>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <p>Ushbu loyihani o'chirishni istaysizmi?</p>
              <div className="confirmation-actions">
                <button 
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button 
                  className="confirm-delete-btn"
                  onClick={deleteProject}
                >
                  O'chirish
                </button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default BigProjectCard;